// extracted by mini-css-extract-plugin
export default {"root":"RadioInput_root__rm60z"};